<template>
  <div>
    <div class="badge-side-by-side text-center" v-for="item in totalization" :key="item.title">
      <div class="badge-totalization" :class="item.classCss">
        <i :class="item.classIcon"></i>
        <span class="title-totalization"> {{ item.title }} </span>
        <span>{{ item.value | currency }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableTotalization",
  props: {
    totalization: Array,
  },
};
</script>

<style scoped>
.badge-side-by-side {
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 10px;
}

.badge-totalization {
  border: 1px solid #e6e7eb;
  padding: 3px 8px 3px 8px;
  border-radius: 30px;
  font-size: 13px;
}

.title-totalization{
  margin-left: 1px;
}

.revenue {
  color: darkblue;
}

.expense {
  color: red;
}
</style>
